import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function RoleRoute({ roles, children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <div className="text-sm text-[#3F3F3F]">Loading...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  // Superadmin only ever lives on /superadmin
  if (user.role === "superadmin" && (!roles || !roles.includes("superadmin"))) {
    return <Navigate to="/superadmin" replace />;
  }
  // Block non-Active users from operational pages (admin/superadmin always Active by seed)
  if (user.role !== "admin" && user.role !== "superadmin" && user.status && user.status !== "Active") {
    return <Navigate to="/pending" replace />;
  }
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={defaultRoute(user.role)} replace />;
  }
  return children;
}

export function defaultRoute(role, status) {
  if (status && status !== "Active" && role !== "admin" && role !== "superadmin") return "/pending";
  if (role === "collector") return "/collect";
  if (role === "facility") return "/facility";
  if (role === "admin") return "/admin";
  if (role === "viewer") return "/viewer";
  if (role === "superadmin") return "/superadmin";
  return "/login";
}
